
import { makeRequest } from 'utils/requestLogger';

const generateGoogleClassroomTokens = (payload) =>
  makeRequest('post', `/api/integrations/google/sso/tokens`, payload);

const getCoursesFromGoogleClassroom = () =>
  makeRequest('get', `/api/integrations/google/sso/courses`);

const getStudentsFromGoogleClassroomCourse = (google_course_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${google_course_id}/students`);

const generateSubscriptionGoogleClassroomTokens = (id, payload) =>
  makeRequest('post', `/api/integrations/google/sso/courses/${id}/tokens/subscription`, payload);

const getGoogleClassroomCourses = (id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/courses`);

const syncGoogleClassroomCourse = (id, google_course_id, payload) =>
  makeRequest('put', `/api/integrations/google/sso/courses/${id}/sync-course/${google_course_id}`, payload);

const getGoogleClassroomCourseStudents = (id, google_course_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/students`);

const getGoogleClassroomCourseTeachers = (id, google_course_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/teachers`);

const disconnectGoogleClassroomIntegration = (id, payload) =>
  makeRequest('put', `/api/integrations/google/sso/courses/${id}/disconnect-course`, payload);

const disconnectStudentGoogleClassroomIntegration = (course_id) =>
  makeRequest('put', `/api/integrations/google/sso/courses/${course_id}/disconnect-student`);

const unsyncGoogleClassroomStudentFromCourse = (course_id, payload) =>
  makeRequest('put', `api/integrations/google/sso/courses/${course_id}/unsync-student`, payload);

const createGoogleClassroomCourseAssignment = (id, google_course_id, activity_type, activity_id, payload) =>
  makeRequest('post', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments`, payload);

const updateGoogleClassroomCourseAssignment = (id, google_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('put', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}`, payload);

const getGoogleClassroomCourseAssignment = (id, google_course_id, activity_type, activity_id, assignment_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}`);

const getGoogleClassroomAssignmentSubmissions = (id, google_course_id, activity_type, activity_id, assignment_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/submissions`);

const createGoogleClassroomAssignmentSubmission = (id, google_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/submissions`, payload);

const syncGoogleClassroomAssignmentGrades = (id, google_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/submissions/sync-grades`, payload);

const disconnectGoogleClassroomAssignment = (id, google_course_id, activity_type, activity_id, assignment_id, payload) =>
  makeRequest('post', `/api/integrations/google/sso/courses/${id}/courses/${google_course_id}/activities/${activity_type}/${activity_id}/assignments/${assignment_id}/disconnect`, payload);

const gradeClassroomStudentsJobStatus = (id, job_id) =>
  makeRequest('get', `/api/integrations/google/sso/courses/${id}/job/${job_id}`);

const disconnectClassroomIntegrationAccount = () =>
  makeRequest('put', `/api/integrations/google/sso/disconnect-account`);

export default {
  generateGoogleClassroomTokens,
  getCoursesFromGoogleClassroom,
  getStudentsFromGoogleClassroomCourse,
  generateSubscriptionGoogleClassroomTokens,
  getGoogleClassroomCourses,
  syncGoogleClassroomCourse,
  getGoogleClassroomCourseStudents,
  getGoogleClassroomCourseTeachers,
  disconnectGoogleClassroomIntegration,
  disconnectStudentGoogleClassroomIntegration,
  unsyncGoogleClassroomStudentFromCourse,
  createGoogleClassroomCourseAssignment,
  updateGoogleClassroomCourseAssignment,
  getGoogleClassroomCourseAssignment,
  getGoogleClassroomAssignmentSubmissions,
  createGoogleClassroomAssignmentSubmission,
  syncGoogleClassroomAssignmentGrades,
  disconnectGoogleClassroomAssignment,
  gradeClassroomStudentsJobStatus,
  disconnectClassroomIntegrationAccount,
};


// WEBPACK FOOTER //
// ./src/app/services/googleClassroom/googleClassroomServices.js